import initializeExtensibilityContext from './actions/initializeExtensibilityContext';
import { runAfterInitialRender } from 'owa-delayed-initialization';
export { default as surfaceActionsStore } from './store/store';
// Export synchronous utils and types
export { getComposeActionDisplayName, getReadActionDisplayName, DIVIDER_DISPLAY_NAME, } from './utils/getDisplayNameFromKey';
export { getComposeActionIconName, getReadActionIconName } from './utils/getIconNameFromKey';
export { getComposeStaticActions, getReadStaticActions, shouldAddActionToEnd, shouldActionBeOnSurface, } from './utils/getStaticActions';
export { default as getAddinCollection } from './utils/getAddinCollection';
export { default as populateCommandBarWithAddins } from './utils/populateCommandBarWithAddins';
export { logUserAction, onCommandBarDataReduced, onCommandBarDataGrown, } from './utils/telemetryUtils';
runAfterInitialRender(function () {
    initializeExtensibilityContext();
});
//# sourceMappingURL=index.js.map